import { occFetch, occUrl } from "~/app/api/occ/occFetch";

type FavouriteData = {
  assetID: string;
  addToFavourite: boolean;
};

export async function addToFavourites(data: FavouriteData) {
  const apiUrl = occUrl("/media-library/favourite");
  const response = await occFetch(apiUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`Error status: ${response.status}`);
  }

  return response.status;
}
